import React from 'react'
import { SVGProps } from 'react'

const ChevronPrevIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M9.8777 0.619616C9.5363 0.277574 8.98213 0.277503 8.64064 0.619454L3.7135 5.55333C3.33192 5.93671 3.1177 6.4556 3.1177 6.9965C3.1177 7.5374 3.33192 8.05629 3.7135 8.43967L8.64706 13.3805C8.98851 13.7224 9.5427 13.7223 9.884 13.3802C10.2244 13.039 10.2243 12.4866 9.88369 12.1456L4.94783 7.203C4.89315 7.1483 4.86244 7.07413 4.86244 6.99679C4.86244 6.91945 4.89315 6.84528 4.94783 6.79058L9.8775 1.85469C10.2182 1.51353 10.2183 0.960883 9.8777 0.619616Z" />
  </svg>
)
export default ChevronPrevIcon
